/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     消息中心-站内信 API 接口
  | @Version:   2018-12-10  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function getMessageEventApi() {
  return request({
    url: '?c=fnc&a=message&do=event',
    method: 'get'
  })
}

export function getMessageListApi(query) {
  return request({
    url: '?c=fnc&a=message&do=list',
    method: 'get',
    params: query
  })
}

export function readMessageApi(id) {
  return request({
    url: '?c=fnc&a=message&do=read',
    method: 'post',
    data: { id }
  })
}
